var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 47.5C14.25 43.0736 14.25 40.8604 14.9731 39.1145C15.9373 36.7868 17.7868 34.9373 20.1145 33.9731C21.8604 33.25 24.0736 33.25 28.5 33.25H85.5C89.9265 33.25 92.1395 33.25 93.8856 33.9731C96.2131 34.9373 98.0628 36.7868 99.027 39.1145C99.75 40.8604 99.75 43.0736 99.75 47.5V80.75C99.75 89.7066 99.75 94.1849 96.9674 96.9675C94.1849 99.75 89.7066 99.75 80.75 99.75H76H38H33.25C24.2933 99.75 19.815 99.75 17.0325 96.9675C14.25 94.1849 14.25 89.7066 14.25 80.75V47.5Z",
    stroke: "url(#paint0_linear_971_1687)",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.25V23.75C38 18.5033 42.2533 14.25 47.5 14.25H66.5C71.7468 14.25 76 18.5033 76 23.75V33.25",
    stroke: "url(#paint1_linear_971_1687)",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 47.5C15.1342 53.7539 17.7412 59.5355 21.639 64.4642C29.4244 74.309 42.3594 80.75 57 80.75C71.6405 80.75 84.5757 74.309 92.3609 64.4642C96.2588 59.5355 98.866 53.7539 99.75 47.5",
    stroke: "url(#paint2_linear_971_1687)",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.625 61.75H59.375",
    stroke: "url(#paint3_linear_971_1687)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_971_1687",
    x1: 57,
    y1: 33.25,
    x2: 57,
    y2: 99.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_971_1687",
    x1: 57,
    y1: 14.25,
    x2: 57,
    y2: 33.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_971_1687",
    x1: 57,
    y1: 47.5,
    x2: 57,
    y2: 80.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_971_1687",
    x1: 57,
    y1: 61.75,
    x2: 57,
    y2: 62.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/Jobs.4c53890c2eaa540dae7da4ea42101af6.svg";
export { ForwardRef as ReactComponent };